import { AssetType, OnboardingFulfilledBy, Role, UserType } from '@nemuru-eng/js-api-client';

import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { ApplicationType } from '@/config/types';

const CORE_ROLES = {
  SUPER_ADMIN: Role.ROLE_SUPER_ADMIN,
  ADMIN: Role.ROLE_ADMIN,
  MERCHANT: Role.ROLE_MERCHANT,
  MERCHANT_GROUP: Role.ROLE_MERCHANT_GROUP,
  CHANNEL: Role.ROLE_CHANNEL,
  AGENT: Role.ROLE_AGENT,
  LENDER: Role.ROLE_LENDER,
  PARTNER: Role.ROLE_PARTNER,
  CPC_BACK_OFFICE: Role.ROLE_CPC_BACK_OFFICE,
};

export const APP_ROLES = {
  ...CORE_ROLES,
  THIRD_PARTY_VALIDATION: Role.ROLE_THIRD_PARTY_VALIDATION,
  IBC_CALL_CENTER: Role.ROLE_IBC_CALL_CENTER,
};

export const ALL_CORE_APP_ROLES = [...Object.values(CORE_ROLES)];
export const ALL_APP_ROLES = [...Object.values(APP_ROLES)];

const CORE_USER_TYPES = {
  SUPER_ADMIN: UserType.SUPER_ADMIN,
  ADMIN: UserType.ADMIN,
  MERCHANT_GROUP: UserType.MERCHANT_GROUP,
  MERCHANT: UserType.MERCHANT,
  CHANNEL: UserType.CHANNEL,
  AGENT: UserType.AGENT,
  PARTNER: UserType.PARTNER,
  LENDER: UserType.LENDER,
  CPC_BACK_OFFICE: UserType.CPC_BACK_OFFICE,
};

export const APP_USER_TYPES = {
  ...CORE_USER_TYPES,
  // FRONTEND_ADMIN: UserType.FRONTEND_ADMIN,
  // FRONTEND_LANDING: UserType.FRONTEND_LANDING,
  // RISK: UserType.RISK,
  // COMMERCIAL: UserType.COMMERCIAL,
  // TASK_RUNNER: UserType.TASK_RUNNER,
  // THIRD_PARTY: UserType.THIRD_PARTY,
  // THIRD_PARTY_RISK: UserType.THIRD_PARTY_RISK,
  THIRD_PARTY_VALIDATION: UserType.THIRD_PARTY_VALIDATION,
  // PAY_BY_LINK: UserType.PAY_BY_LINK,
};

export const ALL_CORE_APP_USER_TYPES = [...Object.values(CORE_USER_TYPES)];
export const ALL_APP_USER_TYPES = [...Object.values(APP_USER_TYPES)];

export const ICON_NAMES = {
  HOME: 'home',
  SUPER_ADMIN: 'add_moderator',
  ADMIN: 'admin_panel_settings',
  LENDER: 'account_balance',
  MERCHANT: 'business',
  CHANNEL: 'wifi_tethering',
  AGENT: 'account_circle',
  PARTNER: 'supervised_user_circle',
  THIRD_PARTY_VALIDATION: 'check_circle_outline',
  CPC_BACK_OFFICE: 'support_agent',
  BORROWER: 'person',
  CO_BORROWER: 'person',
  CONSUMER_LOAN: 'handshake',
  AUTO: 'directions_car',
  AUTOMOBILE: 'directions_car',
  CREDIT_LINE: 'wallet',
  CARD: 'credit_card',
  CREDIT_CARD: 'credit_card',
  CARD_PAYMENT: 'credit_card',
  A2A_PAYMENT: 'wallet',
  ORDER: 'sell',
  PAY_BY_LINK: 'shopping_cart',
  BNPL: 'sell',
  PAYOUTS: 'payments',
  PRICINGS: 'receipt_long',
  APPLICATION: 'add',
  PRODUCT: 'shopping_bag',
  ONLINE_PRODUCT: 'shopping_bag',
  SERVICE: 'emoji_people',
  ACCOMMODATION: 'hotel',
  FLIGHT: 'flight',
  FLIGHT_SMALL: 'flight_takeoff',
  TRAVEL: 'beach_access',
  EDUCATION: 'school',
  HEALTH: 'medical_information',
  INSTALLATION: 'roofing',
  MOBILITY: 'commute',
  RETAIL: 'store',
  UTILITIES_SUPPLY: 'solar_power',
  HOME_IMPROVEMENT: 'house',
  OTHERS: 'more',
  CHECKOUT_SESSION: 'shopping_basket',
  SIMULATOR: 'speed',
  OTHER: 'grid_view',
  FUNNEL: 'filter_alt',
  INTEGRATIONS: 'code',
  REPORTS: 'account_balance',
  USERS: 'key',
  SIGNATURE: 'draw',
};

export const PRODUCTS_BY_ASSET_TYPE: Record<AssetType, ApplicationType> = {
  // never use directly, use ApplicationTypeMap
  [AssetType.EDUCATION]: ApplicationType.CONSUMER_LOAN,
  [AssetType.OTHER]: ApplicationType.CONSUMER_LOAN,
  [AssetType.TRAVEL]: ApplicationType.CONSUMER_LOAN,
  [AssetType.HEALTH]: ApplicationType.CONSUMER_LOAN,
  [AssetType.HOME_IMPROVEMENT]: ApplicationType.CONSUMER_LOAN,
  [AssetType.UTILITIES_SUPPLY]: ApplicationType.CONSUMER_LOAN,
  [AssetType.MINIMAL_AUTO]: ApplicationType.CONSUMER_LOAN,
  [AssetType.MINIMAL]: ApplicationType.CONSUMER_LOAN,

  [AssetType.AUTO]: ApplicationType.AUTO,

  [AssetType.CREDIT_LINE]: ApplicationType.CREDIT_LINE,
  [AssetType.CARD]: ApplicationType.CARD,

  [AssetType.ORDER]: ApplicationType.ORDER,
};

export const APPLICATION_TYPES_BY_ONBOARDING_FULFILLED: Record<OnboardingFulfilledBy, ApplicationType> = {
  // never use directly, use ApplicationTypeMap
  [OnboardingFulfilledBy.BORROWER_ONLINE]: ApplicationType.ORDER,
  [OnboardingFulfilledBy.PAY_BY_LINK]: ApplicationType.PAY_BY_LINK,
};

export const DETAILS_PATH_BY_PRODUCT = {
  [ApplicationType.AUTO]: DYNAMIC_PAGE_PATHS.AUTO_LOAN,
  [ApplicationType.CONSUMER_LOAN]: DYNAMIC_PAGE_PATHS.CONSUMER_LOAN,
  [ApplicationType.CREDIT_LINE]: DYNAMIC_PAGE_PATHS.CREDIT_LINE,
  [ApplicationType.CARD]: DYNAMIC_PAGE_PATHS.CREDIT_CARD,
  [ApplicationType.ORDER]: DYNAMIC_PAGE_PATHS.ORDER,
  [ApplicationType.PAY_BY_LINK]: DYNAMIC_PAGE_PATHS.PAY_BY_LINK,
  [ApplicationType.CHECKOUT_SESSION]: DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_DETAIL,
  [ApplicationType.A2A_PAYMENT]: DYNAMIC_PAGE_PATHS.A2A_PAYMENT,
  [ApplicationType.CARD_PAYMENT]: DYNAMIC_PAGE_PATHS.CARD_PAYMENT,
};
